module.exports = __webpack_public_path__ + "static/media/notificacion_categoria_nominas.948d4794.png";